import { NavLink } from 'react-router-dom';
import { ClipboardList, BarChart3, Plus } from 'lucide-react';

export const Main = () => {
  const linkStyle =
    'bg-white p-8 rounded-lg border-2 border-gray-200 no-underline hover:border-cyan-500 hover:shadow-lg transition-all text-center group';
  const iconStyle = 'w-12 h-12 mx-auto mb-4 text-cyan-500';
  const buttonTitleStyle = 'text-xl font-normal text-gray-900 mb-2';
  const buttonDescriptionStyle = 'text-gray-600 text-sm';

  return (
    <div className="flex flex-col min-h-screen">
      <div className="bg-gradient-to-br from-cyan-50 to-white pt-12">
        <div className="flex flex-col items-center mb-12">
          <h2 className="text-4xl md:text-5xl font-light text-black mb-4">Manage Feedback</h2>
          <p className="text-xl text-gray-600 font-light">
            Create, view, and analyze user feedback.
          </p>
        </div>

        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6">
            <NavLink to="/create-form" className={linkStyle}>
              <Plus className={iconStyle} />
              <h3 className={buttonTitleStyle}>Create Form</h3>
              <p className={buttonDescriptionStyle}>Generate a form to embed on a site</p>
            </NavLink>

            <NavLink to="/forms" className={linkStyle}>
              <ClipboardList className={iconStyle} />
              <h3 className={buttonTitleStyle}>See All Forms</h3>
              <p className={buttonDescriptionStyle}>View and manage submitted feedback</p>
            </NavLink>

            <NavLink to="/analytics" className={linkStyle}>
              <BarChart3 className={iconStyle} />
              <h3 className={buttonTitleStyle}>Analytics</h3>
              <p className={buttonDescriptionStyle}>Analyze feedback trends and metrics</p>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};
